import { server } from './styled-jsx.es';
export { server };
export default server;